"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPicker = void 0;
require("../../libexternal/ColorPick/ColorPick");
var ColorPicker = (function () {
    function ColorPicker(element) {
        this.element = element;
        this.OnCreate();
    }
    ColorPicker.prototype.OnCreate = function () {
        var $propertyId = $(this.element).attr('id');
        var $hiddenElement = $('[name="' + $propertyId + '"]', this.element);
        var initialColor = $hiddenElement.val();
        var options = {
            allowRecent: false,
            initialColor: initialColor,
            palette: [
                '#ffcdd2', '#f8bbd0', '#e1bee7', '#d1c4e9', '#e8eaf6', '#bbdefb', '#b3e5fc', '#b2ebf2', '#b2dfdb', '#c8e6c9',
                '#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3', '#03a9f4', '#00bcd4', '#009688', '#4caf50',
                '#b71c1c', '#880e4f', '#4a148c', '#311b92', '#1a237e', '#0d47a1', '#01579b', '#006064', '#004d40', '#1b5e20',
                '#dcedc8', '#f0f4c3', '#fff9c4', '#ffecb3', '#ffe0b2', '#ffccbc', '#d7ccc8', '#e0e0e0', '#cfd8dc', '#b1bace',
                '#8bc34a', '#cddc39', '#ffeb3b', '#ffc107', '#ff9800', '#ff5722', '#795548', '#9e9e9e', '#607d8b', '#45526e',
                '#33691e', '#827717', '#f57f17', '#ff6f00', '#e65100', '#bf360c', '#3e2723', '#424242', '#37474f', '#1c2a48'
            ]
        };
        $('.color-picker', this.element).colorPick(options);
        $(this.element).on('onColorSelected', function (e, data) {
            $($hiddenElement).val(data.color);
        });
    };
    return ColorPicker;
}());
exports.ColorPicker = ColorPicker;
